const FORM_SELECTOR = '.lucid-newsletter__form';

document.addEventListener('submit', (event) => {
  const form = event.target instanceof HTMLFormElement ? event.target : null;
  if (!form || !form.matches(FORM_SELECTOR)) return;
  const button = form.querySelector('[type="submit"]');
  if (!button) return;
  if (button.getAttribute('aria-busy') === 'true') {
    event.preventDefault();
    return;
  }
  button.setAttribute('aria-busy', 'true');
});

window.addEventListener('pageshow', () => {
  document.querySelectorAll(`${FORM_SELECTOR} [type="submit"][aria-busy]`).forEach((button) => {
    button.removeAttribute('aria-busy');
  });
});

const success = document.querySelector('.lucid-newsletter__success');
if (success) success.focus({ preventScroll: true });
